class JoyaCartHandler {
  constructor() {
    this.init();
  }

  init() {
    const wrappers = document.querySelectorAll('.joya-wrapper');
    wrappers.forEach((wrapper) => this.bindWrapper(/** @type {HTMLElement} */ (wrapper)));
  }

  /**
   * @param {HTMLElement} wrapper
   */
  bindWrapper(wrapper) {
    if (wrapper.dataset.joyaHandlerBound === 'true') return;

    const form = this.resolveForm(wrapper);
    if (!(form instanceof HTMLFormElement)) return;

    const syncFn = () => this.sync(wrapper, form);

    wrapper.addEventListener('joya:sync', syncFn);
    wrapper.addEventListener('input', syncFn);
    wrapper.addEventListener('change', syncFn);
    form.addEventListener('submit', syncFn);

    form.addEventListener('input', (event) => {
      const target = /** @type {HTMLElement} */ (event.target);
      if (target.matches && target.matches('input[name="id"], input[name="quantity"]')) {
        syncFn();
      }
    });

    wrapper.dataset.joyaHandlerBound = 'true';
    syncFn();
  }

  /**
   * @param {HTMLElement} wrapper
   * @returns {HTMLFormElement|null}
   */
  resolveForm(wrapper) {
    const formId = wrapper.dataset.productFormId;
    if (formId) {
      const byId = document.getElementById(formId);
      if (byId instanceof HTMLFormElement) return byId;
      if (byId instanceof HTMLElement) {
        const nested = byId.querySelector('form[action*="/cart/add"]');
        if (nested instanceof HTMLFormElement) return nested;
      }
    }

    const section = wrapper.closest('.shopify-section');
    if (section) {
      const scoped = section.querySelector('form[action*="/cart/add"]');
      if (scoped instanceof HTMLFormElement) return scoped;
    }

    const fallback = document.querySelector('form[action*="/cart/add"]');
    return fallback instanceof HTMLFormElement ? fallback : null;
  }

  /**
   * @param {HTMLElement} wrapper
   * @param {HTMLFormElement} form
   */
  sync(wrapper, form) {
    this.clearJoyaInputs(form);

    const joyaModo = wrapper.dataset.joyaModo || 'placas';
    const mainVariantId = this.getInputValue(form, 'input[name="id"]');
    const quantityRaw = this.getInputValue(form, 'input[name="quantity"]');
    const mainQuantity = Math.max(1, parseInt(quantityRaw || '1', 10) || 1);

    const grabadoSections = Array.from(wrapper.querySelectorAll('[data-joya-grabado-section]'))
      .filter((el) => el instanceof HTMLElement && !/** @type {HTMLElement} */ (el).hidden);

    const patitoSection = wrapper.querySelector('[data-joya-patito-section]');

    const appendGrabadoAddons = (/** @type {number} */ addonIndex) => {
      let idx = addonIndex;
      grabadoSections.forEach((section) => {
        if (!(section instanceof HTMLElement)) return;
        const side = section.dataset.joyaGrabadoSection;
        const placaIndex = section.dataset.placaIndex || '';
        const input = section.querySelector('[data-joya-grabado-input]');
        if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLTextAreaElement)) return;

        const text = input.value.trim();
        if (!text) return;

        const variantId = side === 'delantera'
          ? (wrapper.dataset.grabadoDelanteraVariantId || '').trim()
          : (wrapper.dataset.grabadoTraseraVariantId || '').trim();

        let propertyLabel = side === 'delantera'
          ? (wrapper.dataset.labelGrabadoDelantera || 'Grabado delantero')
          : (wrapper.dataset.labelGrabadoTrasera || 'Grabado trasero');
        if (placaIndex) propertyLabel += ' (' + placaIndex + ')';

        if (variantId && variantId !== mainVariantId) {
          this.appendHidden(form, `items[${idx}]id`, variantId);
          this.appendHidden(form, `items[${idx}]quantity`, String(mainQuantity));
          this.appendHidden(form, `items[${idx}]parent_id`, mainVariantId);
          this.appendHidden(form, `items[${idx}]properties[${propertyLabel}]`, text);
          this.appendHidden(form, `items[${idx}]properties[_joya_block]`, `grabado_${side}`);
          idx++;
        }
      });
    };

    const appendPatito = () => {
      if (patitoSection instanceof HTMLElement && !patitoSection.hidden) {
        const patitoChecked = patitoSection.querySelector('[data-joya-patito-option]:checked');
        if (patitoChecked instanceof HTMLInputElement && patitoChecked.value) {
          this.appendHidden(form, 'properties[Patito]', patitoChecked.value);
        }
      }
    };

    const appendCharmMineral = () => {
      const charmSelect = wrapper.querySelector('[data-joya-charm-mineral-select]');
      if (!(charmSelect instanceof HTMLSelectElement) || !charmSelect.value) return;
      const variantId = charmSelect.value;
      if (!variantId || variantId === mainVariantId) return;
      let maxIdx = 0;
      form.querySelectorAll('.joya-addon-input').forEach((el) => {
        const match = (el.getAttribute('name') || '').match(/^items\[(\d+)\]/);
        if (match) maxIdx = Math.max(maxIdx, parseInt(match[1] || '0', 10));
      });
      const idx = maxIdx + 1;
      this.appendHidden(form, `items[${idx}]id`, variantId);
      this.appendHidden(form, `items[${idx}]quantity`, String(mainQuantity));
      this.appendHidden(form, `items[${idx}]parent_id`, mainVariantId);
      this.appendHidden(form, `items[${idx}]properties[_joya_block]`, 'charm_mineral');
    };

    const appendColors = () => {
      const colorSections = Array.from(wrapper.querySelectorAll('[data-joya-color-section]'));
      if (colorSections.length === 0) return;
      const colorLabel = wrapper.dataset.colorLabel || '';
      colorSections.forEach((section) => {
        if (!(section instanceof HTMLElement)) return;
        const select = section.querySelector('[data-joya-color-select]');
        if (!(select instanceof HTMLSelectElement) || !select.value) return;
        const placaIdx = section.dataset.placaIndex || '';
        const suffix = colorSections.length > 1 ? ` (${placaIdx})` : '';
        const label = colorLabel ? `Color ${colorLabel}${suffix}` : `Color${suffix}`;
        this.appendHidden(form, `properties[${label}]`, select.value);
      });
    };

    const grabadoOpcional = wrapper.dataset.grabadoOpcional === 'true';

    if (joyaModo === 'directo') {
      const missingGrabado = !grabadoOpcional && grabadoSections.find((section) => {
        const input = section.querySelector('[data-joya-grabado-input]');
        return (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) && !input.value.trim();
      });

      if (missingGrabado) {
        this.toggleAddToCart(form, true);
        this.setError(wrapper, wrapper.dataset.msgGrabadoRequired || 'Completa el texto de grabado.');
        return;
      }

      this.toggleAddToCart(form, false);
      this.setError(wrapper, '');

      if (!mainVariantId) return;

      appendGrabadoAddons(1);
      appendPatito();
      appendColors();
      appendCharmMineral();
      return;
    }

    // Modo placas/unidades
    const tipoUnidad = wrapper.dataset.tipoUnidad || 'placa';
    const nPlacas = this.getNPlacas(wrapper);

    if (nPlacas > 0) {
      const missingGrabado = !grabadoOpcional && grabadoSections.find((section) => {
        const input = section.querySelector('[data-joya-grabado-input]');
        return (input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement) && !input.value.trim();
      });

      if (missingGrabado) {
        this.toggleAddToCart(form, true);
        this.setError(wrapper, wrapper.dataset.msgGrabadoRequired || 'Completa el texto de grabado.');
        return;
      }
    }

    this.toggleAddToCart(form, false);
    this.setError(wrapper, '');

    if (nPlacas === 0 || !mainVariantId) return;

    let addonIndex = 1;

    const placaVariantId = (wrapper.dataset.placaAddonVariantId || '').trim();
    if (placaVariantId && placaVariantId !== mainVariantId) {
      const addonQty = tipoUnidad === 'patito' ? (nPlacas - 1) * mainQuantity : nPlacas * mainQuantity;
      if (addonQty > 0) {
        this.appendHidden(form, `items[${addonIndex}]id`, placaVariantId);
        this.appendHidden(form, `items[${addonIndex}]quantity`, String(addonQty));
        this.appendHidden(form, `items[${addonIndex}]parent_id`, mainVariantId);
        this.appendHidden(form, `items[${addonIndex}]properties[_joya_block]`, 'placas');
        addonIndex++;
      }
    }

    appendGrabadoAddons(addonIndex);

    if (tipoUnidad === 'patito') {
      wrapper.querySelectorAll('[data-joya-patito-unit-select]').forEach((sel) => {
        if (!(sel instanceof HTMLSelectElement)) return;
        const unitIdx = sel.dataset.placaIndex || '';
        const val = sel.value;
        if (val) {
          const label = nPlacas > 1 ? `Patito (${unitIdx})` : 'Patito';
          this.appendHidden(form, `properties[${label}]`, val);
        }
      });
    } else {
      appendPatito();
    }

    appendColors();
    appendCharmMineral();
  }

  /**
   * @param {HTMLElement} wrapper
   * @returns {number}
   */
  getNPlacas(wrapper) {
    const select = wrapper.querySelector('[data-joya-placas-select]');
    if (!(select instanceof HTMLSelectElement)) return 0;
    return Math.max(0, parseInt(select.value || '0', 10) || 0);
  }

  /**
   * @param {HTMLFormElement} form
   */
  clearJoyaInputs(form) {
    form.querySelectorAll('.joya-addon-input').forEach((el) => el.remove());
  }

  /**
   * @param {HTMLFormElement} form
   * @param {string} name
   * @param {string} value
   */
  appendHidden(form, name, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.className = 'joya-addon-input';
    form.appendChild(input);
  }

  /**
   * @param {HTMLElement|HTMLFormElement} root
   * @param {string} selector
   * @returns {string}
   */
  getInputValue(root, selector) {
    const input = root.querySelector(selector);
    return input instanceof HTMLInputElement ? input.value : '';
  }

  /**
   * @param {HTMLFormElement} form
   * @param {boolean} disabled
   */
  toggleAddToCart(form, disabled) {
    const button = form.querySelector('button[name="add"]');
    if (!(button instanceof HTMLButtonElement)) return;

    if (disabled) {
      button.disabled = true;
      button.dataset.joyaDisabled = 'true';
      return;
    }

    if (button.dataset.joyaDisabled === 'true') {
      button.disabled = false;
      delete button.dataset.joyaDisabled;
    }
  }

  /**
   * @param {HTMLElement} wrapper
   * @param {string} message
   */
  setError(wrapper, message) {
    const errorNode = wrapper.querySelector('[data-joya-error]');
    if (!(errorNode instanceof HTMLElement)) return;

    if (!message) {
      errorNode.textContent = '';
      errorNode.classList.add('hidden');
      return;
    }

    errorNode.textContent = message;
    errorNode.classList.remove('hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  /** @type {any} */ (window).joyaCartHandler = new JoyaCartHandler();
});
